/*
 * ms-zusatzleistungen.js · Messe-Shop24
 * Zusatzleistungen (erweiterter Datencheck, Formatanpassung, Lanyard-Andruckmuster)
 * als verknüpfte Unterposition (nested cart line) am Produkt.
 *
 * - Produktseite: Auswahl in snippets/ms-zusatzleistungen.liquid
 *   Nach erfolgreichem Hinzufügen (Events on:cart:add / on:line-item:change aus Canopys
 *   product-form.js) hängt nachEvent() die Zusatzleistung an – ohne Eingriff in Canopy-Dateien.
 * - Warenkorb/Drawer: Buttons [data-mszl-add] aus snippets/cart-items.liquid
 */
(function () {
  if (window.msZusatz) return;

  const routes = (window.theme && window.theme.routes) || {};
  const CART = routes.cart || '/cart';
  const CART_ADD = routes.cartAdd || '/cart/add';

  const box = (productId) => document.querySelector(`[data-mszl][data-product-id="${productId}"]`);

  /** Gewählte Leistungs-Variante einer Box oder null. */
  function gewaehlt(b) {
    if (!b || ohneDruck(b)) return null;
    if (b.dataset.stufe === 'Lanyard') {
      const am = b.querySelector('[data-mszl-am]');
      return am && am.checked ? { id: b.dataset.am, name: 'Andruckmuster inkl. Versand' } : null;
    }
    const opt = b.querySelector('input[type="radio"]:checked');
    const wert = opt ? opt.value : 'eigen';
    if (wert === 'fa' && b.dataset.fa) return { id: b.dataset.fa, name: 'Formatanpassung' };
    if (wert === 'eigen') {
      const dc = b.querySelector('[data-mszl-dc]');
      if (dc && dc.checked && b.dataset.dc) return { id: b.dataset.dc, name: 'Erweiterter Datencheck' };
    }
    return null;
  }


  /** „In den Warenkorb“ bei Neugestaltung sperren (nur Buttons, die wir selbst gesperrt haben, wieder freigeben). */
  function warenkorbButtons(b) {
    const form = document.querySelector('form.js-product-form-main');
    if (!form) return [];
    const btns = Array.from(form.querySelectorAll('[name="add"], .shopify-payment-button button'));
    if (form.id) btns.push(...document.querySelectorAll(`[form="${form.id}"][name="add"]`));
    document.querySelectorAll('sticky-atc-panel [name="add"], .sticky-atc [name="add"]').forEach((el) => btns.push(el));
    return btns;
  }
  function atcSperren(b, sperren) {
    warenkorbButtons(b).forEach((btn) => {
      if (sperren) {
        if (btn.dataset.mszlGesperrt) return;
        btn.dataset.mszlGesperrt = '1';
        btn.dataset.mszlAriaVorher = btn.getAttribute('aria-disabled') || '';
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('title', 'Neugestaltung läuft über ein Angebot, nicht über den Warenkorb');
        btn.classList.add('mszl-atc-gesperrt');
      } else if (btn.dataset.mszlGesperrt) {
        const vorher = btn.dataset.mszlAriaVorher;
        if (vorher) btn.setAttribute('aria-disabled', vorher); else btn.removeAttribute('aria-disabled');
        btn.removeAttribute('title');
        btn.classList.remove('mszl-atc-gesperrt');
        delete btn.dataset.mszlGesperrt;
        delete btn.dataset.mszlAriaVorher;
      }
    });
  }


  function aktuelleVariante() {
    const form = document.querySelector('form.js-product-form-main');
    const id = form && form.querySelector('[name="id"]');
    return id ? String(id.value) : '';
  }
  function ohneDruck(b) {
    const liste = b.dataset.ohneDruck || '';
    const v = aktuelleVariante();
    return !!v && liste.indexOf(`,${v},`) !== -1;
  }


  /** Druckdatenblatt-Link(s) der gewählten Variante aktualisieren. */
  function datenblattAktualisieren(b) {
    const box = b.querySelector('[data-mszl-dd]');
    const daten = b.querySelector('[data-mszl-dd-map]');
    if (!box || !daten) return;
    let map = {};
    try { map = JSON.parse(daten.textContent); } catch (e) { return; }
    const urls = (map[aktuelleVariante()] || []).filter(Boolean);
    const icon = box.querySelector('a svg');
    const iconHtml = icon ? icon.outerHTML : '';
    box.innerHTML = urls.map((u, i) => `<a href="${u}" target="_blank" rel="noopener">${iconHtml}Druckdatenblatt${urls.length > 1 ? ` Teil ${i + 1}` : ''}</a>`).join('');
    box.hidden = urls.length === 0;
  }

  /**
   * Upload-Lift-Feld (App-Block) in die Box holen. Die App verknüpft ihre Felder per
   * form-Attribut mit dem Produktformular, das Verschieben ändert daran nichts.
   */
  function uploadEinbinden(b) {
    const slot = b.querySelector('[data-mszl-upload-slot]');
    if (!slot || slot.childElementCount) return;
    const bereich = b.closest('quick-add-drawer') || document;
    const app = bereich.querySelector(`[data-upload-lift="${b.dataset.productId}"]`);
    if (!app) return;
    slot.appendChild(app.closest('.shopify-app-block') || app);
  }

  /** Upload-Bereich unter die gewählte Option setzen und passend beschriften. */
  function uploadAktualisieren(b, wert) {
    const up = b.querySelector('[data-mszl-upload]');
    if (!up) return;
    if (!up.querySelector('[data-mszl-upload-slot]').childElementCount) { up.hidden = true; return; }
    let art = null;
    let anker = null;
    if (b.dataset.stufe === 'Lanyard') {
      art = 'lanyard';
    } else if (wert === 'fa') {
      art = 'fa';
      anker = b.querySelector('input[value="fa"]').closest('label');
    } else if (wert === 'eigen') {
      art = 'eigen';
      anker = b.querySelector('[data-mszl-dc-wrap]') || b.querySelector('input[value="eigen"]').closest('label');
    }
    up.hidden = !art;
    if (!art) return;
    if (anker && anker.nextElementSibling !== up) anker.after(up);
    up.querySelector('[data-mszl-upload-titel]').textContent = up.dataset[`titel${art[0].toUpperCase()}${art.slice(1)}`];
    up.querySelector('[data-mszl-upload-text]').textContent = up.dataset[`text${art[0].toUpperCase()}${art.slice(1)}`];
  }

  /**
   * Warenkorb: Originalname, Typ, Größe und Pixelmaße der Druckdaten ergänzen.
   * Upload-Lift merkt sich jede hochgeladene Datei im Browser (localStorage „cl_files…“, Feld url).
   * In anderen Browsern gibt es diese Daten nicht – dann bleibt der Name aus dem Link, Pixelmaße kommen aus dem Bild.
   */
  function uploadMeta() {
    // window.msDruckdatenMeta: Datei-Daten aus der Upload-Lift-Instanz (Bestell-Upload-Seite)
    const map = Object.assign({}, window.msDruckdatenMeta || {});
    // eigener Speicher: Datei-Daten, gesichert bevor das Produktseiten-Feld nach dem Hinzufügen geleert wird
    try { Object.assign(map, JSON.parse(localStorage.getItem('mszl-dd-meta') || '{}')); } catch (e) { /* egal */ }
    try {
      for (let i = 0; i < localStorage.length; i += 1) {
        const k = localStorage.key(i);
        if (!k || k.indexOf('cl_files') !== 0) continue;
        const liste = JSON.parse(localStorage.getItem(k));
        if (Array.isArray(liste)) liste.forEach((f) => { if (f && f.url) map[f.url] = f; });
      }
    } catch (e) { /* kein Zugriff auf localStorage */ }
    return map;
  }
  function dateigroesse(b) {
    return b >= 1e6 ? `${(b / 1e6).toFixed(1).replace('.', ',')} MB` : `${Math.max(1, Math.round(b / 1e3))} KB`;
  }
  function druckdatenInfos(root) {
    const els = (root || document).querySelectorAll('[data-mszl-dd-url]:not([data-mszl-dd-fertig])');
    if (!els.length) return;
    const meta = uploadMeta();
    els.forEach((el) => {
      el.dataset.mszlDdFertig = '1';
      const url = el.dataset.mszlDdUrl;
      const f = meta[url];
      const nameEl = el.matches('[data-mszl-dd-name]') ? el : el.querySelector('[data-mszl-dd-name]');
      if (f && f.name && nameEl) nameEl.textContent = f.name;
      const info = el.querySelector('[data-mszl-dd-info]');
      if (!info) return;
      const name = (f && f.name) || url.split('?')[0].split('/').pop();
      infoAufbauen(el, info, url, f, name).catch(() => {
        info.textContent = 'Datei konnte nicht geprüft werden';
        info.hidden = false;
      });
    });
  }

  /** Direkter Speicher-Link: upload.cloudlift.app leitet ohne CORS-Header weiter, der Google-Speicher erlaubt Lesen. */
  function speicherUrl(url) {
    return url.replace(/^https:\/\/upload\.cloudlift\.app\/s\//, 'https://storage.googleapis.com/cloudlift-app-cloud-prod-upload/');
  }
  function mmText(v) {
    return Math.round(v).toLocaleString('de-DE');
  }

  async function infoAufbauen(el, info, url, f, name) {
    const ext = name.indexOf('.') !== -1 ? name.split('.').pop().toUpperCase() : '';
    const teile = ext ? [ext] : [];
    let bytes = f && (f.size || (f.meta && f.meta.contentLength));
    if (ext === 'PDF') {
      await pdfPruefen(el, info, url, teile, bytes);
      return;
    }
    if (!bytes) {
      try {
        const r = await fetch(speicherUrl(url), { method: 'HEAD' });
        bytes = Number(r.headers.get('x-goog-stored-content-length') || r.headers.get('content-length')) || 0;
      } catch (e) { /* ohne Größe weiter */ }
    }
    if (bytes) teile.push(dateigroesse(bytes));
    const img = el.querySelector('img');
    let w = f && f.meta && f.meta.width;
    let h = f && f.meta && f.meta.height;
    if (!w && img) {
      if (!(img.complete && img.naturalWidth)) {
        await new Promise((ok) => {
          img.addEventListener('load', ok, { once: true });
          img.addEventListener('error', ok, { once: true });
        });
      }
      w = img.naturalWidth;
      h = img.naturalHeight;
    }
    if (w && h) teile.push(`${w} × ${h} px`);
    info.textContent = teile.join(' · ');
    info.hidden = !teile.length;
    if (w && h) aufloesungPruefen(el, w, h);
  }

  /*
   * PDF-Vorab-Check (nur Warenkorb-Seite, pdf.js wird erst bei einer PDF geladen):
   * Endformat (TrimBox, sonst Seitengröße), Beschnitt, Seitenzahl, Größe, Vorschau der 1. Seite und
   * – wenn breite_cm/hohe_cm bekannt – Abgleich mit dem Produkt (auch Maßstab 1:10).
   * Farbprofil und Bildauflösung in der PDF prüft erst der erweiterte Datencheck.
   */
  const PDFJS = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/';
  let pdfjsLaden = null;
  function pdfjs() {
    if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
    if (!pdfjsLaden) {
      pdfjsLaden = new Promise((ok, fehler) => {
        const s = document.createElement('script');
        s.src = `${PDFJS}pdf.min.js`;
        s.onload = () => {
          window.pdfjsLib.GlobalWorkerOptions.workerSrc = `${PDFJS}pdf.worker.min.js`;
          ok(window.pdfjsLib);
        };
        s.onerror = fehler;
        document.head.appendChild(s);
      });
    }
    return pdfjsLaden;
  }
  /** TrimBox der ersten Seite aus den Rohdaten (pdf.js gibt nur die sichtbare Seitengröße heraus). */
  function trimBox(buf) {
    const text = new TextDecoder('latin1').decode(new Uint8Array(buf));
    const m = text.match(/\/TrimBox\s*\[\s*([-\d.]+)\s+([-\d.]+)\s+([-\d.]+)\s+([-\d.]+)\s*\]/);
    return m ? m.slice(1).map(Number) : null;
  }
  async function pdfPruefen(el, info, url, teile, bytes) {
    info.textContent = 'PDF · wird geprüft …';
    info.hidden = false;
    const res = await fetch(speicherUrl(url));
    if (!res.ok) throw new Error(res.status);
    const buf = await res.arrayBuffer();
    teile.push(dateigroesse(bytes || buf.byteLength));
    const trim = trimBox(buf);
    const lib = await pdfjs();
    const doc = await lib.getDocument({ data: new Uint8Array(buf) }).promise;
    teile.push(doc.numPages === 1 ? '1 Seite' : `${doc.numPages} Seiten`);
    const seite = await doc.getPage(1);
    const mm = (pt) => (pt * (seite.userUnit || 1) * 25.4) / 72;
    const [x0, y0, x1, y1] = seite.view;
    let media = { w: mm(x1 - x0), h: mm(y1 - y0) };
    let end = trim ? { w: mm(trim[2] - trim[0]), h: mm(trim[3] - trim[1]) } : media;
    if (seite.rotate % 180) {
      media = { w: media.h, h: media.w };
      end = { w: end.h, h: end.w };
    }
    const beschnitt = trim ? Math.max(0, (media.w - end.w) / 2) : 0;
    teile.push(`Endformat ${mmText(end.w)} × ${mmText(end.h)} mm${beschnitt >= 0.5 ? ` + ${mmText(beschnitt)} mm Beschnitt` : ''}`);
    info.textContent = teile.join(' · ');
    pdfAbgleich(el, end, !!trim);
    pdfVorschau(el, seite).catch(() => {});
  }
  async function pdfVorschau(el, seite) {
    const platz = el.querySelector('.mszl-dd__typ');
    if (!platz) return;
    const v = seite.getViewport({ scale: 1 });
    const vp = seite.getViewport({ scale: 96 / Math.max(v.width, v.height) });
    const c = document.createElement('canvas');
    c.width = Math.ceil(vp.width);
    c.height = Math.ceil(vp.height);
    c.className = 'mszl-dd__pdf';
    await seite.render({ canvasContext: c.getContext('2d'), viewport: vp }).promise;
    platz.replaceWith(c);
  }
  function pdfAbgleich(el, end, hatTrim) {
    const liste = el.closest('[data-druck-b]');
    const B = liste ? parseFloat(liste.dataset.druckB) * 10 || 0 : 0;
    const H = liste ? parseFloat(liste.dataset.druckH) * 10 || 0 : 0;
    const ziel = el.querySelector('.mszl-dd__text') || el;
    const zeile = (klasse, text) => {
      const s = document.createElement('span');
      s.className = klasse;
      s.textContent = text;
      ziel.appendChild(s);
    };
    const massCheck = 'Endformat und Beschnitt laut Druckdatenblatt prüft unser kostenloser Maß-Check vor dem Druck.';
    if (!B && !H) {
      zeile('mszl-dd__check', `Bitte mit dem Druckdatenblatt abgleichen. ${massCheck}`);
      return;
    }
    // Faktor 1 oder 10 (Maßstab 1:10); ohne TrimBox darf die Seite bis 40 mm Beschnitt größer sein
    const passt = (ist, soll) => {
      if (!soll) return -1;
      const tol = soll * 0.01 + 1;
      const oben = hatTrim ? tol : 40 + tol;
      for (const faktor of [1, 10]) {
        const d = ist * faktor - soll;
        if (d >= -tol && d <= oben) return faktor;
      }
      return 0;
    };
    const fb = passt(end.w, B);
    const fh = passt(end.h, H);
    const soll = [B ? `${mmText(B)} mm breit` : '', H ? `${mmText(H)} mm hoch` : ''].filter(Boolean).join(', ');
    if (fb === 0 || fh === 0) {
      // Entschärft (05.10.2026): breite_cm/hohe_cm sind teils Gestell- statt Druckmaße – kein Warnhinweis, nur Abgleich-Bitte
      zeile('mszl-dd__check', `Bitte mit dem Druckdatenblatt abgleichen. ${massCheck}`);
      return;
    }
    const skala = fb === 10 || fh === 10 ? ' (Maßstab 1:10)' : '';
    zeile('mszl-dd__ok', `✓ Passt zum Produkt: ${soll}${skala}`);
    zeile('mszl-dd__check', massCheck);
  }

  /**
   * Hinweis, wenn ein Bild im Endformat unter MIN_DPI liegt. Endformat aus breite_cm/hohe_cm
   * (data-druck-b/-h an der Liste); maßgeblich ist die schwächere Richtung.
   */
  const MIN_DPI = 100;
  function aufloesungPruefen(el, w, h) {
    const liste = el.closest('[data-druck-b]');
    const b = liste ? parseFloat(liste.dataset.druckB) : 0;
    const hoehe = liste ? parseFloat(liste.dataset.druckH) : 0;
    const werte = [];
    if (b > 0) werte.push(w / (b / 2.54));
    if (hoehe > 0) werte.push(h / (hoehe / 2.54));
    if (!werte.length) return;
    const dpi = Math.round(Math.min(...werte));
    // Seitenverhältnis: Bild quer, Endformat hoch (oder umgekehrt) → Motiv müsste stark beschnitten/verzerrt werden
    if (b > 0 && hoehe > 0 && !el.querySelector('.mszl-dd__format')) {
      const abweichung = Math.abs(Math.log((w / h) / (b / hoehe)));
      if (abweichung > 0.15) {
        const lage = (x) => (x > 1.05 ? 'quer' : x < 0.95 ? 'hoch' : 'quadratisch');
        const fmt = document.createElement('span');
        fmt.className = 'mszl-dd__warnung mszl-dd__format';
        fmt.textContent = `⚠ Seitenverhältnis passt nicht: Das Bild ist ${lage(w / h)} (${w} × ${h} px), das Endformat ${lage(b / hoehe)} (${String(b).replace('.', ',')} × ${String(hoehe).replace('.', ',')} cm). Das Motiv müsste stark beschnitten oder verzerrt werden.`;
        (el.querySelector('.mszl-dd__text') || el).appendChild(fmt);
      }
    }
    if (dpi >= MIN_DPI || el.querySelector('.mszl-dd__warnung:not(.mszl-dd__format)')) return;
    const format = [b > 0 ? `${String(b).replace('.', ',')} cm breit` : '', hoehe > 0 ? `${String(hoehe).replace('.', ',')} cm hoch` : ''].filter(Boolean).join(', ');
    const hinweis = document.createElement('span');
    hinweis.className = 'mszl-dd__warnung';
    hinweis.textContent = `⚠ Auflösung zu gering: ca. ${dpi} dpi im Endformat (${format}). Empfohlen sind mind. ${MIN_DPI} dpi, sonst wirkt der Druck unscharf. Tipp: Mit dem erweiterten Datencheck (kostenpflichtige Zusatzleistung) prüft unser Grafikbüro deine Datei vor dem Druck.`;
    (el.querySelector('.mszl-dd__text') || el).appendChild(hinweis);
  }

  /**
   * Upload direkt im Warenkorb: startet in [data-mszl-dd-upload] ein Upload-Lift-Feld (öffentliche Klasse
   * Cloudlift.upload.lib.UploadField, Konfiguration des Produktfelds „Druckdaten“). Das Feld steckt in einem
   * per JS erzeugten <form action="/cart/add"> (die App sucht ein solches Formular; im HTML wäre es ein
   * verschachteltes Formular im Warenkorb-Formular). „Druckdaten übernehmen“ hängt die Dateien per
   * /cart/change an die Position. Hängt von App-Interna ab – bei App-Updates prüfen.
   */
  function uploadLiftBereit() {
    const cl = window.Cloudlift && window.Cloudlift.upload;
    if (!cl || !cl.lib || !cl.lib.UploadField || !cl.config) return null;
    const feld = (cl.config.fields || []).find((f) => f.fieldProperty === 'properties' && /druckdaten/i.test(f.field || ''));
    return feld ? { cl, feld } : null;
  }
  function uploadFeldStarten(box) {
    if (box.dataset.mszlDdGestartet) return true;
    const bereit = uploadLiftBereit();
    if (!bereit) return false;
    box.dataset.mszlDdGestartet = '1';
    const { cl, feld } = bereit;
    const form = document.createElement('form');
    form.action = '/cart/add';
    form.className = 'mszl-dd__form';
    form.addEventListener('submit', (e) => e.preventDefault());
    // Canopy aktualisiert bei jedem change-Event in <cart-items> die Menge – Upload-Events abfangen
    form.addEventListener('change', (e) => e.stopPropagation());
    const ziel = document.createElement('div');
    form.appendChild(ziel);
    box.querySelector('[data-mszl-dd-slot]').appendChild(form);
    try {
      // eslint-disable-next-line no-new
      new cl.lib.UploadField(Object.assign({}, feld, { label: '', required: false }), {
        api: cl.config.api,
        assets: cl.config.assets,
        selector: ziel,
        queryParams: { shop: cl.config.shop },
        product: { id: Number(box.dataset.productId), handle: box.dataset.handle, title: box.dataset.title },
        extensions: cl.config.extensions
      });
    } catch (err) {
      ziel.innerHTML = '<p class="mszl-dd__hinweis m-0">Upload hier gerade nicht möglich – bitte per Mail an service@messe-shop24.de nachreichen.</p>';
      return true;
    }
    const knopf = box.querySelector('[data-mszl-dd-speichern]');
    const timer = setInterval(() => {
      if (!box.isConnected) { clearInterval(timer); return; }
      if (knopf) knopf.hidden = !neueDruckdaten(form).some(([, v]) => /^https?:/.test(v));
    }, 700);
    return true;
  }
  function neueDruckdaten(form) {
    return Array.from(form.querySelectorAll('input[name^="properties["]'))
      .filter((i) => i.value)
      .map((i) => [i.name.slice('properties['.length, -1), i.value]);
  }
  async function druckdatenUebernehmen(box, knopf) {
    const form = box.querySelector('form.mszl-dd__form');
    const neu = form ? neueDruckdaten(form) : [];
    if (!neu.some(([, v]) => /^https?:/.test(v))) return;
    knopf.disabled = true;
    knopf.textContent = 'Wird übernommen …';
    try {
      const cart = await (await fetch(`${CART}.js`)).json();
      const zeile = cart.items.find((i) => i.key === box.dataset.key);
      if (!zeile) throw new Error('Position nicht gefunden');
      const properties = {};
      let max = 0;
      Object.entries(zeile.properties || {}).forEach(([k, v]) => {
        if (k === '_druckdaten' || v === '' || v === null) return;
        properties[k] = v;
        const m = k.match(/^_?Druckdaten_(\d+)$/);
        if (m) max = Math.max(max, Number(m[1]));
      });
      // Nummern der neuen Dateien hinter den vorhandenen fortsetzen (Druckdaten_1 → Druckdaten_3 …)
      neu.forEach(([k, v]) => {
        const name = k.replace(/^(Druckdaten)_(\d+)(.*)$/, (_, f, n, rest) => `${f}_${Number(n) + max}${rest}`);
        properties[name] = v;
      });
      const res = await fetch(`${routes.cartChange || '/cart/change'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: zeile.key, quantity: zeile.quantity, properties })
      });
      if (!res.ok) throw new Error(res.status);
      window.location.reload();
    } catch (err) {
      knopf.disabled = false;
      knopf.textContent = 'Druckdaten übernehmen';
      knopf.insertAdjacentHTML('afterend', `<span class="mszl-cart__fehler">${err.message}</span>`);
    }
  }
  function uploadFelderStarten() {
    document.querySelectorAll('[data-mszl-dd-upload][data-auto]:not([data-mszl-dd-gestartet])').forEach((box) => uploadFeldStarten(box));
  }
  window.addEventListener('upload:app', () => setTimeout(uploadFelderStarten, 0));

  function preisText(label) {
    const el = label && label.querySelector('.mszl__preis');
    return el ? el.firstChild.textContent.trim() : '';
  }

  /** Box-Zustand aktualisieren (Sichtbarkeit, Zusammenfassung). */
  function aktualisieren(b) {
    const aus = ohneDruck(b);
    b.classList.toggle('mszl--aus', aus);
    const ausText = b.querySelector('[data-mszl-aus-text]');
    if (ausText) ausText.hidden = !aus;
    if (aus) {
      const eigen = b.querySelector('input[value="eigen"]');
      if (eigen) eigen.checked = true;
      b.querySelectorAll('input[type="checkbox"]').forEach((c) => { c.checked = false; });
    }
    const opt = b.querySelector('input[type="radio"]:checked');
    const wert = opt ? opt.value : null;
    const dcWrap = b.querySelector('[data-mszl-dc-wrap]');
    if (dcWrap) {
      dcWrap.hidden = wert !== 'eigen';
      if (wert !== 'eigen') dcWrap.querySelector('input').checked = false;
    }
    const neu = b.querySelector('[data-mszl-neu]');
    if (neu) neu.hidden = wert !== 'neu';
    uploadAktualisieren(b, wert);
    atcSperren(b, wert === 'neu');
    const hinweis = b.querySelector('[data-mszl-grafik-hinweis]');
    if (hinweis) hinweis.hidden = !(wert === 'fa' || wert === 'neu');

    const summe = b.querySelector('[data-mszl-summe]');
    const auswahl = gewaehlt(b);
    if (!summe) return;
    if (wert === 'neu') {
      summe.textContent = 'Neugestaltung auf Angebot';
    } else if (auswahl) {
      let label = null;
      if (auswahl.id === b.dataset.dc) label = b.querySelector('[data-mszl-dc-wrap]');
      else if (auswahl.id === b.dataset.am) label = b.querySelector('[data-mszl-am]').closest('label');
      else label = b.querySelector('input[value="fa"]').closest('label');
      summe.textContent = `${auswahl.name} ${preisText(label)}`;
    } else {
      summe.textContent = 'ohne Zusatzleistung';
    }
  }

  function fehler(b, text) {
    const el = b && b.querySelector('[data-mszl-fehler]');
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
  }

  async function hinzufuegen(variantId, parentKey, titel, sections) {
    const body = {
      items: [{
        id: Number(variantId),
        quantity: 1,
        parent_line_key: parentKey,
        properties: { 'Für Artikel': titel }
      }]
    };
    if (sections) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }
    const res = await fetch(`${CART_ADD}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.description || json.message || res.status);
    return json;
  }


  /** Aktuell gewählte Variante und Menge des Produktformulars in die Anfrage übernehmen. */
  function produktUebernehmen(d) {
    const daten = d.querySelector('[data-mszl-varianten]');
    const form = document.querySelector('form.js-product-form-main');
    if (!daten || !form) return;
    let map = {};
    try { map = JSON.parse(daten.textContent); } catch (e) { return; }
    const idFeld = form.querySelector('[name="id"]');
    const v = idFeld && map[idFeld.value];
    const mengeFeld = form.elements.namedItem('quantity') || document.querySelector(`[name="quantity"][form="${form.id}"]`);
    const menge = mengeFeld && mengeFeld.value ? mengeFeld.value : '1';
    const setze = (sel, wert, attr) => { const el = d.querySelector(sel); if (el) { if (attr) el.value = wert; else el.textContent = wert; } };
    if (v) {
      const variante = v.t === 'Default Title' ? '' : v.t;
      setze('[data-mszl-p-variante]', variante);
      setze('[data-mszl-f-variante]', variante, true);
      setze('[data-mszl-p-sku]', v.s || '–');
      setze('[data-mszl-f-sku]', v.s || '', true);
      setze('[data-mszl-f-link]', v.u, true);
    }
    setze('[data-mszl-p-menge]', menge);
    setze('[data-mszl-f-menge]', menge, true);
  }


  /** Warenkorb-Seite und Drawer neu rendern. */
  function warenkorbNeuLaden() {
    const drawer = document.querySelector('cart-drawer');
    const seite = window.location.pathname === CART
      ? Array.from(document.querySelectorAll('cart-items')).find((el) => !el.closest('cart-drawer'))
      : null;
    if (seite && typeof seite.refreshCartItems === 'function') seite.refreshCartItems();
    if (drawer && typeof drawer.refreshCartDrawer === 'function') drawer.refreshCartDrawer();
    if (!drawer && !seite) window.location.reload();
  }

  window.msZusatz = {
    /**
     * Hängt nach dem Hinzufügen des Produkts die gewählte Leistung an.
     * @param {object} data – Antwort von /cart/add (einzelne Position)
     * @param {string} sections – Section-IDs wie im Theme-Request
     * @returns {object|null} Antwort mit neuen Sections oder null
     */
    async nachHinzufuegen(data, sections) {
      const b = box(data.product_id);
      const auswahl = gewaehlt(b);
      if (!auswahl || !data.key) return null;
      fehler(b, '');
      try {
        const cart = await (await fetch(`${CART}.js`)).json();
        const schonDa = cart.items.some((i) => i.parent_relationship
          && i.parent_relationship.parent_key === data.key
          && String(i.variant_id) === String(auswahl.id));
        if (schonDa) return null;
        const titel = data.product_title + (data.variant_title ? ` – ${data.variant_title}` : '');
        return await hinzufuegen(auswahl.id, data.key, titel, sections);
      } catch (e) {
        fehler(b, `Das Produkt liegt im Warenkorb, die Zusatzleistung konnte aber nicht hinzugefügt werden (${e.message}). Du kannst sie im Warenkorb nachtragen.`);
        return null;
      }
    }
  };

  /*
   * Checkout vorbereiten: Der Checkout zeigt alle Eigenschaften ohne „_“ – also die nackten Upload-Links.
   * Pro Druckposition ([data-mszl-dd-upload][data-key] auf der Warenkorb-Seite) daher
   *   Druckdaten_N(_name) → _Druckdaten_N(_name)   (im Checkout/Kunden-Mails versteckt, an der Bestellung gespeichert)
   *   Druckdaten = „hochgeladen (n Dateien)“ bzw. „fehlen – …“ (sichtbarer Status im Checkout)
   * Läuft beim Laden der Warenkorb-Seite (nicht beim Klick auf „Auschecken“ – den übernimmt u. a. BSS B2B).
   * Der Drawer führt nur noch zur Warenkorb-Seite, daher läuft jeder Checkout hier vorbei.
   */
  /*
   * Prüfergebnis je Datei als Text für die interne Bestell-Mail („Neue Bestellung“ zeigt _Druckdaten_N_info).
   * Gleiche Logik wie die Anzeige im Warenkorb, ohne DOM. Vergleich mit dem hinterlegten Produktmaß
   * (custom.breite_cm/hohe_cm – teils Gestell- statt Druckmaß, daher in der Mail „Produktmaß“ genannt).
   * Ergebnis wird je URL + Maß im Browser zwischengespeichert ('mszl-dd-check').
   */
  function passtMass(ist, soll, hatTrim) {
    if (!soll) return -1;
    const tol = soll * 0.01 + 1;
    const oben = hatTrim ? tol : 40 + tol;
    for (const faktor of [1, 10]) {
      const d = ist * faktor - soll;
      if (d >= -tol && d <= oben) return faktor;
    }
    return 0;
  }
  function bildMasse(url) {
    return new Promise((ok) => {
      const i = new Image();
      i.onload = () => ok([i.naturalWidth, i.naturalHeight]);
      i.onerror = () => ok(null);
      i.src = url;
    });
  }
  async function dateiAnalyse(url, bCm, hCm) {
    const schluessel = `${url}|${bCm}|${hCm}`;
    let cache = {};
    try { cache = JSON.parse(localStorage.getItem('mszl-dd-check') || '{}'); } catch (e) { /* egal */ }
    if (cache[schluessel]) return cache[schluessel];
    const B = bCm * 10;
    const H = hCm * 10;
    const produkt = [bCm ? `${String(bCm).replace('.', ',')} cm breit` : '', hCm ? `${String(hCm).replace('.', ',')} cm hoch` : ''].filter(Boolean).join(', ');
    const ext = url.split('?')[0].split('.').pop().toLowerCase();
    let text = '';
    try {
      if (ext === 'pdf') {
        const res = await fetch(speicherUrl(url));
        if (!res.ok) return '';
        const buf = await res.arrayBuffer();
        const trim = trimBox(buf);
        const lib = await pdfjs();
        const doc = await lib.getDocument({ data: new Uint8Array(buf) }).promise;
        const seite = await doc.getPage(1);
        const mm = (pt) => (pt * (seite.userUnit || 1) * 25.4) / 72;
        const [x0, y0, x1, y1] = seite.view;
        let media = { w: mm(x1 - x0), h: mm(y1 - y0) };
        let end = trim ? { w: mm(trim[2] - trim[0]), h: mm(trim[3] - trim[1]) } : media;
        if (seite.rotate % 180) { media = { w: media.h, h: media.w }; end = { w: end.h, h: end.w }; }
        const beschnitt = trim ? Math.max(0, (media.w - end.w) / 2) : 0;
        text = `PDF · ${doc.numPages === 1 ? '1 Seite' : `${doc.numPages} Seiten`} · Endformat ${mmText(end.w)} × ${mmText(end.h)} mm${beschnitt >= 0.5 ? ` + ${mmText(beschnitt)} mm Beschnitt` : ' (kein Beschnitt erkannt)'}`;
        if (B || H) {
          const fb = passtMass(end.w, B, !!trim);
          const fh = passtMass(end.h, H, !!trim);
          text += (fb === 0 || fh === 0)
            ? ` · ⚠ weicht vom Produktmaß ab (${produkt})`
            : ` · ✓ passt zum Produktmaß (${produkt})${(fb === 10 || fh === 10) ? ', Maßstab 1:10' : ''}`;
        }
      } else if (['jpg', 'jpeg', 'png', 'gif', 'webp'].indexOf(ext) !== -1) {
        const m = await bildMasse(url);
        if (!m) return '';
        const [w, h] = m;
        text = `${ext.toUpperCase()} · ${w} × ${h} px`;
        const werte = [];
        if (B) werte.push(w / (bCm / 2.54));
        if (H) werte.push(h / (hCm / 2.54));
        if (werte.length) {
          const dpi = Math.round(Math.min(...werte));
          text += ` · ca. ${dpi} dpi beim Produktmaß (${produkt})${dpi < MIN_DPI ? ' ⚠ zu gering' : ' ✓'}`;
          if (B && H && Math.abs(Math.log((w / h) / (bCm / hCm))) > 0.15) text += ' · ⚠ Seitenverhältnis passt nicht';
        }
      } else {
        text = `${ext.toUpperCase()}-Datei – keine automatische Prüfung`;
      }
    } catch (e) { return ''; }
    try { cache[schluessel] = text; localStorage.setItem('mszl-dd-check', JSON.stringify(cache)); } catch (e) { /* egal */ }
    return text;
  }
  function produktMassFuerZeile(key) {
    const upload = Array.from(document.querySelectorAll('[data-mszl-dd-upload][data-key]')).find((el) => el.dataset.key === key && !el.closest('cart-drawer'));
    const liste = upload && upload.closest('.mszl-dd') && upload.closest('.mszl-dd').querySelector('[data-druck-b]');
    return liste ? [parseFloat(liste.dataset.druckB) || 0, parseFloat(liste.dataset.druckH) || 0] : [0, 0];
  }

  async function druckdatenFuerKasse(mitAnalyse) {
    const keys = Array.from(document.querySelectorAll('[data-mszl-dd-upload][data-key]'))
      .filter((el) => !el.closest('cart-drawer'))
      .map((el) => el.dataset.key);
    if (!keys.length) return 0;
    let geaendert = 0;
    const cart = await (await fetch(`${CART}.js`)).json();
    for (const key of keys) {
      const zeile = cart.items.find((i) => i.key === key);
      if (!zeile) continue;
      const [bCm, hCm] = produktMassFuerZeile(key);
      const alt = zeile.properties || {};
      const properties = {};
      let dateien = 0;
      for (const [k, v] of Object.entries(alt)) {
        if (k === '_druckdaten' || k === 'Druckdaten' || v === '' || v === null) continue;
        const m = k.match(/^_?(Druckdaten_\d+.*)$/);
        if (!m) { properties[k] = v; continue; }
        if (/_info$/.test(m[1])) continue; // wird für vorhandene Dateien neu erzeugt
        properties[`_${m[1]}`] = v;
        if (/^https?:/.test(v) && !/_name$/.test(m[1])) {
          dateien += 1;
          if (mitAnalyse) {
            // eslint-disable-next-line no-await-in-loop
            const info = await dateiAnalyse(v, bCm, hCm);
            if (info) properties[`_${m[1]}_info`] = info;
          } else if (alt[`_${m[1]}_info`]) {
            properties[`_${m[1]}_info`] = alt[`_${m[1]}_info`]; // vorhandenes Ergebnis behalten
          }
        }
      }
      properties.Druckdaten = dateien
        ? `hochgeladen (${dateien} ${dateien === 1 ? 'Datei' : 'Dateien'})`
        : 'fehlen – bitte per Mail an service@messe-shop24.de nachreichen (Anhänge max. 20 MB)';
      if (JSON.stringify(properties) === JSON.stringify(alt)) continue;
      // eslint-disable-next-line no-await-in-loop
      const res = await fetch(`${routes.cartChange || '/cart/change'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: zeile.key, quantity: zeile.quantity, properties })
      });
      if (!res.ok) throw new Error(res.status);
      geaendert += 1;
    }
    return geaendert;
  }

  async function kasseVorbereiten() {
    if (window.location.pathname !== CART) return;
    let versuche = 0;
    try { versuche = Number(sessionStorage.getItem('mszl-kasse') || 0); } catch (e) { /* egal */ }
    const neuLaden = () => {
      try { sessionStorage.setItem('mszl-kasse', String(versuche + 1)); } catch (e) { /* egal */ }
      window.location.reload();
    };
    try {
      // 1. sofort: Links verstecken + Status (schnell, damit kein Checkout mit sichtbaren Links startet)
      if (await druckdatenFuerKasse(false) && versuche < 3) { neuLaden(); return; }
      // 2. danach: Prüfergebnis je Datei für die interne Mail anhängen (PDF-Analyse kann dauern)
      if (await druckdatenFuerKasse(true) && versuche < 3) { neuLaden(); return; }
    } catch (err) {
      console.log('Druckdaten für Kasse', err); // eslint-disable-line no-console
    }
    try { sessionStorage.removeItem('mszl-kasse'); } catch (e) { /* egal */ }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kasseVorbereiten);
  else kasseVorbereiten();

  document.addEventListener('submit', (e) => {
    if (!e.target.matches || !e.target.matches('form.js-product-form-main')) return;
    const b = document.querySelector('[data-mszl]');
    const opt = b && b.querySelector('input[type="radio"]:checked');
    if (opt && opt.value === 'neu') { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  // Produktseite: Änderungen und Anfrage-Dialog
  document.addEventListener('change', (e) => {
    const b = e.target.closest('[data-mszl]');
    if (b) aktualisieren(b);
  });

  document.addEventListener('click', async (e) => {
    const anfrage = e.target.closest('[data-mszl-anfrage]');
    if (anfrage) {
      const b = anfrage.closest('[data-mszl]');
      const d = b && document.getElementById(`${b.id}-dialog`);
      if (d) produktUebernehmen(d);
      if (d && typeof d.showModal === 'function') d.showModal();
      return;
    }
    const zu = e.target.closest('[data-mszl-zu]');
    if (zu) { zu.closest('dialog').close(); return; }

    // Warenkorb: Anzahl einer Zusatzleistung ändern (pro Motiv)
    const qty = e.target.closest('[data-mszl-qty]');
    if (qty) {
      e.preventDefault();
      qty.disabled = true;
      try {
        const res = await fetch(`${routes.cartChange || '/cart/change'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(qty.dataset.line), quantity: Number(qty.dataset.qty) })
        });
        if (!res.ok) throw new Error(res.status);
      } catch (err) { console.log(err); } // eslint-disable-line
      warenkorbNeuLaden();
      return;
    }

    // Warenkorb: eine Druckdaten-Datei (Upload-Lift-Eigenschaft) von der Position entfernen.
    // Shopify ersetzt die Eigenschaften komplett – daher alle übrigen mitschicken. Zusatzleistungen
    // (Unterpositionen) bleiben dabei am Artikel hängen (getestet 04.10.2026).
    // Warenkorb: weiteres Upload-Feld aufklappen / hochgeladene Dateien übernehmen
    const ddMehr = e.target.closest('[data-mszl-dd-mehr]');
    if (ddMehr) {
      e.preventDefault();
      const box = ddMehr.closest('[data-mszl-dd-upload]');
      if (uploadFeldStarten(box)) ddMehr.hidden = true;
      else ddMehr.textContent = 'Upload wird geladen … bitte gleich nochmal klicken';
      return;
    }
    const ddSpeichern = e.target.closest('[data-mszl-dd-speichern]');
    if (ddSpeichern) {
      e.preventDefault();
      druckdatenUebernehmen(ddSpeichern.closest('[data-mszl-dd-upload]'), ddSpeichern);
      return;
    }

    const ddWeg = e.target.closest('[data-mszl-dd-weg]');
    if (ddWeg) {
      e.preventDefault();
      e.stopPropagation();
      ddWeg.disabled = true;
      ddWeg.textContent = 'Wird entfernt …';
      try {
        const cart = await (await fetch(`${CART}.js`)).json();
        const zeile = cart.items.find((i) => i.key === ddWeg.dataset.key);
        if (!zeile) throw new Error('Position nicht gefunden');
        const properties = {};
        Object.entries(zeile.properties || {}).forEach(([k, v]) => {
          if (v === ddWeg.dataset.url) return;
          const basis = k.replace(/_name$/, '');
          if (k !== basis && zeile.properties[basis] === ddWeg.dataset.url) return; // zugehöriger Dateiname
          if (v !== '' && v !== null) properties[k] = v;
        });
        // Leere Eigenschaften wertet Shopify als „nichts ändern“ – unsichtbaren Platzhalter setzen
        if (!Object.keys(properties).length) properties._druckdaten = 'entfernt';
        const res = await fetch(`${routes.cartChange || '/cart/change'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: zeile.key, quantity: zeile.quantity, properties })
        });
        if (!res.ok) throw new Error(res.status);
        // Warenkorb-Seite: neu laden (zwei <cart-items> auf der Seite – Seite + Drawer – Auffrischen per Section unzuverlässig)
        if (window.location.pathname === CART) window.location.reload();
        else warenkorbNeuLaden();
      } catch (err) {
        ddWeg.disabled = false;
        ddWeg.textContent = 'Entfernen';
        ddWeg.insertAdjacentHTML('afterend', `<span class="mszl-cart__fehler">${err.message}</span>`);
      }
      return;
    }

    // Warenkorb: Zusatzleistung nachträglich hinzufügen
    const add = e.target.closest('[data-mszl-add]');
    if (!add) return;
    e.preventDefault();
    add.disabled = true;
    add.classList.add('is-loading');
    try {
      await hinzufuegen(add.dataset.variant, add.dataset.parentKey, add.dataset.titel);
      warenkorbNeuLaden();
    } catch (err) {
      add.disabled = false;
      add.classList.remove('is-loading');
      add.insertAdjacentHTML('afterend', `<span class="mszl-cart__fehler">${err.message}</span>`);
    }
  });

  document.addEventListener('on:variant:change', () => {
    setTimeout(() => {
      document.querySelectorAll('[data-mszl]').forEach((b) => {
        aktualisieren(b);
        datenblattAktualisieren(b);
        const opt = b.querySelector('input[type="radio"]:checked');
        if (opt && opt.value === 'neu') {
          warenkorbButtons(b).forEach((btn) => { delete btn.dataset.mszlGesperrt; });
          atcSperren(b, true);
        }
      });
    }, 50);
  });

  /*
   * Canopy 7: Anschluss über die Events aus product-form.js (on:cart:add / on:line-item:change)
   * statt eines Eingriffs in product-form.js (so in Canopy 6.3.1). Nach dem Anhängen wird der
   * Drawer neu geladen – erst nachdem Canopy ihn selbst gefüllt hat (setTimeout 700 ms in
   * product-form.js), sonst überschreibt Canopy den Stand ohne Zusatzleistung.
   * Voraussetzung: Theme-Einstellung „Nach dem Hinzufügen“ = Drawer (bei „Seite“ leitet Canopy
   * nach 300 ms auf /cart weiter, dann käme die Zusatzleistung zu spät).
   */
  /*
   * Upload-Lift merkt sich Uploads (fileFetch) und leert das Produktseiten-Feld nach dem Hinzufügen nicht
   * (fileSubmitClear aus). Folge: Ein zweiter Artikel derselben Variante geht unbemerkt mit derselben Datei in den
   * Warenkorb und Shopify fasst beide Positionen zusammen. Deshalb nach jedem Hinzufügen leeren (clearFiles der App;
   * die Datei bleibt auf dem Server und am Warenkorb-Artikel). Name/Größe/Pixel vorher in 'mszl-dd-meta' sichern.
   */
  function produktUploadLeeren() {
    const app = window.Cloudlift && window.Cloudlift.upload && window.Cloudlift.upload.App;
    ((app && app.fields) || []).forEach((feld) => {
      if (!feld || !feld._upload || !feld.config || feld.config.fieldProperty !== 'properties') return;
      if (!feld.element || feld.element.closest('[data-mszl-dd-upload]')) return; // Warenkorb-Felder nicht anfassen
      try {
        const gemerkt = JSON.parse(localStorage.getItem('mszl-dd-meta') || '{}');
        Object.values(feld._upload.files || {}).forEach((f) => {
          if (f && f.url && !f.parent) gemerkt[f.url] = { name: f.name, size: f.size, mimeType: f.mimeType, meta: f.meta };
        });
        localStorage.setItem('mszl-dd-meta', JSON.stringify(gemerkt));
      } catch (e) { /* egal */ }
      try { feld.clearFiles(); } catch (e) { /* egal */ }
    });
  }

  async function nachEvent(evt) {
    if (!evt.target.closest || !evt.target.closest('product-form')) return;
    if (!evt.target.querySelector('form.js-product-form-main')) return;
    const variantId = evt.detail && evt.detail.variantId;
    if (!variantId) return;
    setTimeout(produktUploadLeeren, 300);
    const start = Date.now();
    try {
      const cart = await (await fetch(`${CART}.js`)).json();
      const zeile = cart.items.find((i) => String(i.variant_id) === String(variantId) && !i.parent_relationship);
      if (!zeile) return;
      const ergebnis = await window.msZusatz.nachHinzufuegen(zeile, null);
      if (!ergebnis) return;
      const warten = Math.max(0, 900 - (Date.now() - start));
      setTimeout(() => {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.refreshCartDrawer === 'function') drawer.refreshCartDrawer(true);
        else if (window.location.pathname === CART) window.location.reload();
      }, warten);
    } catch (e) {
      // Fehlermeldung setzt nachHinzufuegen() selbst in der Box
    }
  }
  document.addEventListener('on:cart:add', nachEvent);
  document.addEventListener('on:line-item:change', nachEvent);

  function init() {
    document.querySelectorAll('[data-mszl]').forEach((b) => {
      uploadEinbinden(b);
      aktualisieren(b);
      // Nach Absenden der Anfrage: Dialog nur für dieses Formular wieder öffnen
      if (window.location.hash === '#mszl-anfrage-form') {
        const d = document.getElementById(`${b.id}-dialog`);
        if (d && d.querySelector('[data-mszl-auf]') && typeof d.showModal === 'function') d.showModal();
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Druckdaten-Infos im Warenkorb – auch nach jedem Neuaufbau von Seite/Drawer
  function druckdatenStart() {
    druckdatenInfos();
    uploadFelderStarten();
    let t = null;
    new MutationObserver(() => {
      clearTimeout(t);
      t = setTimeout(() => { druckdatenInfos(); uploadFelderStarten(); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }
  /*
   * Druckdaten-Upload nach der Bestellung (Seite /pages/order-upload, Upload-Lift-Baustein „Upload Order“).
   * Upload-Lift baut je Bestellposition .cl-upload--order-item mit Upload-Feld [data-upload-lift-order-item]
   * (data-order-number, data-variant-id) und ordnet die Dateien selbst der Bestellung zu. Wir ergänzen je Position
   * den Druckdaten-Kasten wie im Warenkorb (Vorschau, Name, Größe, Pixel, dpi-/PDF-Check über druckdatenInfos,
   * Entfernen) und blenden „ohne Druck“-Positionen aus. Daten (Maße, Druck ja/nein, Warenkorb-Uploads) aus
   * sections/ms-order-upload-daten.liquid; Datei-Daten neuer Uploads aus Cloudlift.upload.App.fields (App-Interna).
   */
  function escapeHtml(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }
  function bestellUploadDaten() {
    const el = document.getElementById('ms-order-upload-daten');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }
  function bestellUploadFelder(item) {
    const app = window.Cloudlift && window.Cloudlift.upload && window.Cloudlift.upload.App;
    return ((app && app.fields) || []).filter((f) => f && f.element && item.contains(f.element) && f._upload);
  }
  /** Dateien, die aktuell im Upload-Feld stehen (FilePond-Liste) – im Feld entfernte Dateien behält Upload-Lift intern. */
  function neueBestellDateien(item) {
    const dateien = [];
    const gesehen = {};
    const felder = bestellUploadFelder(item);
    felder.forEach((feld) => {
      const pond = feld._upload._pond;
      const files = feld._upload.files || {};
      if (!pond || typeof pond.getFiles !== 'function') return;
      pond.getFiles().forEach((pf) => {
        const f = files[pf.serverId];
        if (!f || f.parent || f.error || !f.url || gesehen[f.url]) return;
        gesehen[f.url] = true;
        dateien.push(Object.assign({ name: pf.filename, size: pf.fileSize }, f));
      });
    });
    if (!felder.length) {
      // Fallback ohne App-Instanz: versteckte Felder des Bestell-Formulars
      item.querySelectorAll('input[name^="order["]').forEach((i) => {
        if (/^https?:/.test(i.value) && !gesehen[i.value]) {
          gesehen[i.value] = true;
          dateien.push({ url: i.value });
        }
      });
    }
    return dateien;
  }
  function bestellDateiEntfernen(item, url) {
    return bestellUploadFelder(item).some((feld) => {
      const pond = feld._upload._pond;
      const files = feld._upload.files || {};
      const pf = pond && pond.getFiles().find((p) => files[p.serverId] && files[p.serverId].url === url);
      if (!pf) return false;
      // revert: Upload-Lift löscht die Datei dann auch auf dem Server (serverDelete auf der Bestell-Upload-Seite)
      pond.removeFile(pf.id, { revert: true });
      return true;
    });
  }
  function dateiZeile(url, name, entfernbar) {
    const ext = url.split('?')[0].split('.').pop().toLowerCase();
    const bild = ['jpg', 'jpeg', 'png', 'gif', 'webp'].indexOf(ext) !== -1;
    const vorschau = bild
      ? `<img src="${escapeHtml(url)}" alt="" width="48" height="48">`
      : `<span class="mszl-dd__typ">${escapeHtml(ext.toUpperCase().slice(0, 4))}</span>`;
    const aktion = entfernbar
      ? `<button type="button" class="mszl-dd__weg" data-mszl-ou-weg data-url="${escapeHtml(url)}">Entfernen</button>`
      : '<span class="mszl-ou__alt">bereits übermittelt</span>';
    return `<li data-mszl-dd-url="${escapeHtml(url)}"><a class="mszl-dd__datei" href="${escapeHtml(url)}" target="_blank" rel="noopener">${vorschau}`
      + `<span class="mszl-dd__text"><span class="mszl-dd__name" data-mszl-dd-name>${escapeHtml(name || url.split('?')[0].split('/').pop())}</span>`
      + `<span class="mszl-dd__info" data-mszl-dd-info hidden></span></span></a>${aktion}</li>`;
  }
  function bestellUploadAufbauen() {
    const items = document.querySelectorAll('.cl-upload--order-item');
    if (!items.length) return;
    const daten = bestellUploadDaten();
    window.msDruckdatenMeta = window.msDruckdatenMeta || {};
    // Zuordnung je Position: zuerst über die Positions-ID (data-item-id = <Positions-ID><Stück-Nr.>), sonst
    // gleiche Varianten der Reihe nach verteilen (z. B. zweimal derselbe Woody mit unterschiedlichen Druckdaten)
    const vergeben = new Set();
    items.forEach((item) => {
      const feld = item.querySelector('[data-upload-lift-order-item]');
      if (!feld) return;
      const nr = String(feld.dataset.orderNumber);
      const itemId = String(feld.dataset.itemId || '');
      let eintrag = daten.find((d) => String(d.o) === nr && d.id && itemId.indexOf(String(d.id)) === 0);
      if (!eintrag) {
        eintrag = daten.find((d, i) => String(d.o) === nr && String(d.v) === String(feld.dataset.variantId) && !vergeben.has(i));
      }
      if (eintrag) vergeben.add(daten.indexOf(eintrag));
      // Positionsnummer (Reihenfolge der Bestellpositionen wie in Shopify) als verstecktes Feld: Upload-Lift schreibt
      // alle order[…]-Felder eines Artikels in die Bestellnotiz → „Position: 1“ ordnet Nachreichungen eindeutig zu
      if (eintrag && !item.querySelector('input[name="order[Position]"]')) {
        const pos = daten.filter((d) => String(d.o) === nr).indexOf(eintrag) + 1;
        if (pos > 0) {
          const inp = document.createElement('input');
          inp.type = 'hidden';
          inp.name = 'order[Position]';
          inp.value = String(pos);
          item.appendChild(inp);
        }
      }
      if (eintrag && !eintrag.druck) {
        item.hidden = true;
        item.style.display = 'none';
        return;
      }
      const vorhanden = (eintrag && eintrag.dateien) || [];
      const neu = neueBestellDateien(item);
      const sig = JSON.stringify([vorhanden.map((d) => d.u), neu.map((d) => d.url)]);
      // Kasten wie im Warenkorb: Überschrift, Liste (Vorschau/Check), darunter das Upload-Lift-Feld
      let kasten = item.querySelector('[data-mszl-ou]');
      if (!kasten) {
        kasten = document.createElement('div');
        kasten.className = 'mszl-dd mszl-ou';
        kasten.setAttribute('data-mszl-ou', '');
        kasten.innerHTML = '<span class="mszl-zl__tag" data-mszl-ou-titel></span><div data-mszl-ou-liste></div>'
          + '<div class="mszl-ou__feld" data-mszl-ou-feld></div>'
          + '<p class="mszl-dd__hinweis m-0">Alternativ per Mail an <a href="mailto:service@messe-shop24.de">service@messe-shop24.de</a> mit Bestellnummer – Anhänge max. 20 MB.</p>';
        (item.querySelector('.cl-upload--order-item-content') || item).appendChild(kasten);
      }
      const feldPlatz = kasten.querySelector('[data-mszl-ou-feld]');
      if (feld.parentElement !== feldPlatz) feldPlatz.appendChild(feld);
      if (kasten.dataset.sig === sig) return;
      kasten.dataset.sig = sig;
      neu.forEach((f) => { window.msDruckdatenMeta[f.url] = f; });
      const zeilen = vorhanden.map((d) => dateiZeile(d.u, d.n, false)).concat(neu.map((f) => dateiZeile(f.url, f.name, true)));
      kasten.classList.toggle('mszl-dd--leer', !zeilen.length);
      kasten.querySelector('[data-mszl-ou-titel]').textContent = zeilen.length ? 'Deine Druckdaten' : 'Druckdaten hochladen';
      kasten.querySelector('[data-mszl-ou-liste]').innerHTML = zeilen.length
        ? `<ul class="mszl-dd__liste" data-druck-b="${escapeHtml(eintrag ? eintrag.b : '')}" data-druck-h="${escapeHtml(eintrag ? eintrag.h : '')}">${zeilen.join('')}</ul>`
        : '<p class="mszl-dd__hinweis m-0">Noch keine Druckdaten zu diesem Artikel. Ziehe deine Datei in das Feld oder klicke auf „Durchsuchen“ – danach siehst du hier Vorschau und Vorab-Check.</p>';
      druckdatenInfos(kasten);
    });
  }
  /*
   * Bestellübersicht: Status offener Bestellungen bei Upload-Lift nachfragen. Beim Absenden speichert Upload-Lift
   * den Abschluss (Tag „upload-complete“) zuerst im eigenen System, die Shopify-Bestellung bekommt ihn verzögert.
   * Abfrage wie Upload-Lift selbst: /api/upload/order/<nr> mit der Kunden-Kennung aus script[data-upload-lift-customer].
   */
  function uploadLiftKennung() {
    const el = document.querySelector('script[data-upload-lift-customer]');
    try {
      const d = JSON.parse((el && el.textContent.trim()) || '{}');
      return d.m && d.s ? `${d.m}.${d.s}` : null;
    } catch (e) { return null; }
  }
  function zeileAbgeschlossen(nr) {
    const z = document.querySelector(`[data-mszl-ou-zeile][data-nr="${nr}"]`);
    if (!z || z.dataset.fehlt !== '1') return;
    z.dataset.fehlt = '0';
    const badge = z.querySelector('[data-mszl-ou-badge]');
    if (badge) {
      badge.className = 'mszl-ou-badge mszl-ou-badge--ok';
      badge.textContent = '✓ Druckdaten hochgeladen';
    }
    const btn = z.querySelector('[data-mszl-ou-btn]');
    if (btn) btn.outerHTML = `<span class="mszl-ou-liste__kontakt">Problem? <a href="tel:+494030386688">040 30 38 66 88</a> · <a href="mailto:service@messe-shop24.de?subject=${encodeURIComponent(`Druckdaten zu Bestellung #${nr}`)}">Mail</a></span>`;
  }
  async function bestellStatusAbgleichen() {
    const cfg = window.Cloudlift && window.Cloudlift.upload && window.Cloudlift.upload.config;
    const kennung = uploadLiftKennung();
    const tag = (cfg && cfg.customer && cfg.customer.tagComplete) || 'upload-complete';
    const zeilen = Array.from(document.querySelectorAll('[data-mszl-ou-zeile][data-fehlt="1"]'));
    for (const z of zeilen) {
      const nr = z.dataset.nr;
      let fertig = false;
      try { fertig = !!localStorage.getItem(`mszl-ou-fertig-${nr}`); } catch (e) { /* egal */ }
      if (!fertig && cfg && cfg.api && kennung) {
        try {
          // eslint-disable-next-line no-await-in-loop
          const r = await fetch(`${cfg.api}/api/upload/order/${nr}?shop=${encodeURIComponent(cfg.shop)}`, { headers: { Authorization: `CL ${kennung}` } });
          if (r.ok) {
            // eslint-disable-next-line no-await-in-loop
            const o = await r.json();
            fertig = !!((o.tags && o.tags.indexOf(tag) !== -1) || (o.status && o.status.tag === tag));
          }
        } catch (e) { /* ohne Abgleich weiter */ }
      }
      if (fertig) zeileAbgeschlossen(nr);
    }
  }
  /** Nach dem Absenden zeigt Upload-Lift [data-order-complete] – dann Zeile sofort umstellen und merken. */
  let bestellNummerAktiv = '';
  function abschlussBeobachten() {
    const block = document.querySelector('[data-upload-lift-order]');
    if (!block) return;
    new MutationObserver(() => {
      const feld = block.querySelector('[data-upload-lift-order-item]');
      if (feld && feld.dataset.orderNumber) bestellNummerAktiv = feld.dataset.orderNumber;
      if (bestellNummerAktiv && block.querySelector(':scope > [data-order-complete]')) {
        try { localStorage.setItem(`mszl-ou-fertig-${bestellNummerAktiv}`, '1'); } catch (e) { /* egal */ }
        zeileAbgeschlossen(bestellNummerAktiv);
      }
    }).observe(block, { childList: true, subtree: true });
  }

  /*
   * Upload-Lift löscht beim Entfernen auf der Bestell-Upload-Seite nur das Original auf dem Server, das automatisch
   * erzeugte Vorschaubild („…_thumbnail“) bleibt in der Upload-Lift-Liste stehen. Beim Entfernen meldet die App jede
   * Datei einzeln mit dem Event „upload:removed“ (Original und Kinder) – Kinder hier über dieselbe Löschfunktion
   * nachlöschen (nur wo serverDelete aktiv ist, also nicht im Warenkorb).
   */
  function vorschaubilderMitloeschen() {
    document.addEventListener('upload:removed', (e) => {
      const f = e.detail;
      if (!f || !f.parent || !f.uuid) return;
      const app = window.Cloudlift && window.Cloudlift.upload && window.Cloudlift.upload.App;
      const feld = ((app && app.fields) || []).find((x) => x && x._upload && x._upload._fileMeta
        && x._upload._fileMeta.settings && x._upload._fileMeta.settings.serverDelete);
      if (!feld) return;
      try {
        feld._upload._fileMeta.removeFile(f).catch(() => {});
      } catch (err) { /* egal */ }
    }, true);
  }

  function bestellUploadStart() {
    if (!document.querySelector('[data-upload-lift-order]')) return;
    bestellStatusAbgleichen();
    abschlussBeobachten();
    vorschaubilderMitloeschen();
    // Link aus der Bestellbestätigung: ?bestellung=1901 → Bestellnummer in Upload-Lifts Eingabefeld eintragen
    let nummer = '';
    try { nummer = (new URLSearchParams(window.location.search).get('bestellung') || '').replace(/\D/g, ''); } catch (e) { /* egal */ }
    if (nummer) bestellNummerAktiv = nummer;
    if (nummer) {
      let versuche = 0;
      const eintragen = setInterval(() => {
        versuche += 1;
        const feld = document.querySelector('.cl-upload--order-input');
        if (feld && !feld.value) {
          feld.value = nummer;
          feld.dispatchEvent(new Event('blur'));
        }
        if (feld || document.querySelector('.cl-upload--order-item') || versuche > 30) clearInterval(eintragen);
      }, 500);
    }
    bestellUploadAufbauen();
    setInterval(bestellUploadAufbauen, 1000);
    document.addEventListener('click', (e) => {
      const weg = e.target.closest('[data-mszl-ou-weg]');
      if (!weg) return;
      e.preventDefault();
      const item = weg.closest('.cl-upload--order-item');
      if (!item || !bestellDateiEntfernen(item, weg.dataset.url)) {
        if (!weg.parentElement.querySelector('.mszl-cart__fehler')) {
          weg.insertAdjacentHTML('afterend', '<span class="mszl-cart__fehler">Bitte im Upload-Feld unten auf × klicken.</span>');
        }
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bestellUploadStart);
  else bestellUploadStart();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', druckdatenStart);
  else druckdatenStart();

  /* Quick-Add-Fenster: Canopy setzt den Inhalt (inkl. Zusatzleistungs-Box) nachträglich per innerHTML ein –
     dann neu initialisieren (Wunsch 04.10.2026). */
  function quickAddBeobachten() {
    const ziel = document.querySelector('quick-add-drawer .js-product-details');
    if (!ziel || ziel.dataset.mszlBeobachtet) return;
    ziel.dataset.mszlBeobachtet = '1';
    new MutationObserver(() => {
      ziel.querySelectorAll('[data-mszl]').forEach((b) => { uploadEinbinden(b); aktualisieren(b); });
    }).observe(ziel, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', quickAddBeobachten);
  else quickAddBeobachten();
}());
